import { Button } from '@mui/material';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

import { replacePathParams } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';
import { TicketFragment } from 'types/api/tickets.types';

import LinkUnstyled from 'components/@common/LinkUnstyled';

import TicketItemAccordion from './TicketItemAccordion';

interface Props {
  ticket: TicketFragment;
  hideInquiryButton?: boolean;
}

const TicketInquiryItem = ({ ticket, hideInquiryButton = false }: Props) => {
  const { query } = useRouter();
  const slug = query.slug?.toString() ?? '';

  return (
    <TicketItemAccordion ticket={ticket}>
      {!hideInquiryButton && (
        <Button
          component={LinkUnstyled}
          href={replacePathParams(Routes.EventInquiry, {
            slug,
            id: ticket.id,
          })}
          // Prevent the accordion from open / closing when clicking the button
          onClick={(e) => e.stopPropagation()}
        >
          <FormattedMessage id="tickets.inquiry.default.request.label" />
        </Button>
      )}
    </TicketItemAccordion>
  );
};

export default TicketInquiryItem;
